module.exports = __webpack_public_path__ + "img/dp_bg.ebf86909.jpg";